import { Component, Input } from '@angular/core';

import { AutocompleteSuggestion } from '~/component/form/autocomplete/interfaces/suggestion.interface';

@Component({
  selector: 'app-form-autocomplete-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
})
export class FormAutocompleteItemComponent {
  @Input() public suggestion: AutocompleteSuggestion;

  public get ariaSelected(): true | null {
    return this.selected ? true : null;
  }

  public get selected(): boolean {
    return this.suggestion.selected;
  }

  public get text(): string {
    return this.suggestion.text;
  }
}
